import React from 'react';
import { Confirm, useDelete, useNotify, useRefresh } from 'react-admin';

export const EfficiencyTestsDeleteDialog = ({
  // @ts-ignore
  showDeleteDialog,
  // @ts-ignore
  setShowDeleteDialog,
  // @ts-ignore
  id
}) => {
  const [erase] = useDelete();
  const notify = useNotify();
  const refresh = useRefresh();
  const onCloseDeleteDialog = () => {
    setShowDeleteDialog(false);
  };

  const onDelete = () => {
    erase(
      'efficiency-tests',
      {
        id
      },
      {
        onSuccess: () => {
          notify('resources.efficiency-tests.notifications.delete.success', {
            type: 'success'
          });
          onCloseDeleteDialog();
          refresh();
        },
        onError(error: any) {
          notify(error.message, { type: 'warning' });
        }
      }
    );
  };

  return (
    <Confirm
      title="resources.efficiency-tests.delete.title"
      content="resources.efficiency-tests.delete.message"
      onConfirm={onDelete}
      isOpen={showDeleteDialog}
      onClose={onCloseDeleteDialog}
    />
  );
};
